import { useTranslation } from '../contexts/translation-context';
import { getTranslatedError } from './get-translated-error';
import { ForcedState, useForcedState } from '../contexts/forced-state-context';
import { useConfig } from '../contexts/config-context';
export const useError = (error, customErrors, fieldType, suffix) => {
  const {
    currency
  } = useConfig();
  const {
    t,
    i18n
  } = useTranslation();
  const forcedState = useForcedState();
  if (forcedState.includes(ForcedState.INPUT_FIELDS_ERROR)) {
    return {
      hasError: true,
      errorMessage: t('input.error.message.required-error-forced')
    };
  }
  if (!error) {
    return {
      hasError: false
    };
  }
  const customErrorMessage = (error == null ? void 0 : error.useCustomErrorMessage) && (error == null ? void 0 : error.errorMessage) || (customErrors == null ? void 0 : customErrors[error.errorType]);
  const errorMessage = customErrorMessage ?? getTranslatedError({
    translation: {
      i18n,
      t
    },
    error,
    fieldType,
    suffix,
    currency: currency == null ? void 0 : currency.sign
  });
  return {
    hasError: true,
    errorMessage
  };
};
//# sourceMappingURL=use-error.js.map